var $ = jQuery.noConflict();

jQuery(document).ready(function () {
    $(document).on('click', '#container-accessibility .access__btn', function (event) {
        var wcag_name = $(this).data('name');
        var wcag_method = $(this).data('method');
        var wcag_class = $(this).data('class');

        $(this).toggleClass('active');

        accessibilityMethod(wcag_name);
        var cookieArr = {};
        $('#container-accessibility .access__btn').each(function () {
            var name = $(this).data('name')
            var active = '';
            if ($(this).hasClass('active')) {
                active = 'active';
            }
            cookieArr[name] = active;
        })

        var cookieJson = JSON.stringify(cookieArr)
        jQuery.cookie('cookie-accessibility', cookieJson, {
            expires: 999,
            path: '/'
        });
    })

    function accessibilityMethod(name) {
        var button = $('#container-accessibility .access__btn[data-name="' + name + '"]')
        var wcag_class = button.data('class');

        if (name == 'greyscale') {
            if (button.hasClass('active')) {
                $('#container-accessibility .access__btn[data-method="color"]').removeClass('active')
                $('#container-accessibility .access__btn[data-method="color"]').attr('aria-pressed', 'false');
                button.attr('aria-pressed', 'true');

                button.addClass('active');

                $('body').attr('data-wcag-color', wcag_class)
            } else {
                button.removeClass('active');
                button.attr('aria-pressed', 'false');
                $('body').attr('data-wcag-color', '')
            }
        }

        if (name == 'text-reg' || name == 'text-lg' || name == 'text-xl') {

            $('#container-accessibility .access__btn[data-method="fontsize"]').attr('aria-pressed', 'false');
            button.attr('aria-pressed', 'true');

            $('#container-accessibility .access__btn[data-method="fontsize"]').removeClass('active')
            button.addClass('active');

            $('body').attr('data-wcag-fontsize', wcag_class)
        }

        if (name == 'cursor') {
            if (!button.hasClass('active')) {
                $('body').attr('data-wcag-cursor', '')
                button.attr('aria-pressed', 'false');
            } else {
                $('body').attr('data-wcag-cursor', wcag_class)
                button.attr('aria-pressed', 'true');
            }
        }

        if (name == 'highlight-links') {
            if (!button.hasClass('active')) {
                $('body').attr('data-wcag-links', '')
                button.attr('aria-pressed', 'false');
            } else {
                $('body').attr('data-wcag-links', wcag_class)
                button.attr('aria-pressed', 'true');
            }
        }
    }

    function accessibilityCookieAnalize() {
        if (jQuery.cookie('cookie-accessibility')) {
            var cookieArr = JSON.parse(jQuery.cookie('cookie-accessibility'));

            $.each(cookieArr, function (key, value) {
                if (value == 'active') {
                    $('#container-accessibility .access__btn[data-name="' + key + '"]').addClass('active')

                    accessibilityMethod(key);
                }
            })
        }
    }

    accessibilityCookieAnalize();
});



